import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/api/v1/auth/authService';

import Main from '@/views/Main';
import StartCampaign from '@/views/StartCampaign';
import ContributionSuccess from '@/views/ContributionSuccess';
// Crowdfunding
import Crowdfunding from '@/views/Crowdfunding/Index';
import CrowdfundingShow from '@/views/Crowdfunding/Show';
import CrowdfundingNew from '@/views/Crowdfunding/New';
import CrowdfundingEdit from '@/views/Crowdfunding/Edit';
// Fundraising
import Fundraising from '@/views/Fundraising/Index';
import FundraisingShow from '@/views/Fundraising/Show';
import FundraisingNew from '@/views/Fundraising/New';
import FundraisingEdit from '@/views/Fundraising/Edit';
// About
import About from '@/views/About/About';
import Contact from '@/views/About/Contact';
import HowItWorks from '@/views/About/HowItWorks';
import Pricing from '@/views/About/Pricing';
import StaticPages from '@/views/About/StaticPages';
// Profile
import Profiles from '@/views/Profile/Index';
import Profile from '@/views/Profile/Show';
import ProfileEdit from '@/views/Profile/Edit';
import ForgotPassword from '@/views/Profile/ForgotPassword';
import ConfirmAccount from '@/views/Profile/ConfirmAccount';
import AcceptTeamInvitation from '@/views/Profile/AcceptTeamInvitation';

import axios from 'axios';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  root: '/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Main,
    },
    {
      path: '/start_campaign',
      component: StartCampaign,
    },
    // Crowdfunding
    {
      path: '/crowdfunding',
      name: 'crowdfunding',
      component: Crowdfunding,
    },
    {
      path: '/crowdfunding/:id(\\d+)/:title',
      name: 'show_crowdfunding',
      component: CrowdfundingShow,
    },
    {
      path: '/crowdfunding/new',
      name: 'new_crowdfunding',
      component: CrowdfundingNew,
      meta: {
        authorize: true,
      },
    },
    {
      path: '/crowdfunding/edit/:id(\\d+):tab?',
      name: 'edit_crowdfunding',
      component: CrowdfundingEdit,
      meta: {
        authorize: true,
      },
    },
    // Fundraising
    {
      path: '/fundraising',
      name: 'fundraising',
      component: Fundraising,
    },
    {
      path: '/fundraising/:id(\\d+)/:title',
      name: 'show_fundraising',
      component: FundraisingShow,
    },
    {
      path: '/fundraising/new',
      name: 'new_fundraising',
      component: FundraisingNew,
      meta: {
        authorize: true,
      },
    },
    {
      path: '/fundraising/edit/:id(\\d+):tab?',
      name: 'edit_fundraising',
      component: FundraisingEdit,
      meta: {
        authorize: true,
      },
    },
    // About
    {
      path: '/about',
      component: About,
    },
    {
      path: '/contact',
      component: Contact,
    },
    {
      path: '/how_it_works',
      component: HowItWorks,
    },
    {
      path: '/Pricing',
      component: Pricing,
    },
    {
      path: '/static/:permalink',
      name: 'static_pages',
      component: StaticPages,
    },
    // Profile
    {
      path: '/profiles',
      name: 'profiles',
      component: Profiles,
    },
    {
      path: '/profile/:id(\\d+)',
      name: 'show_profile',
      component: Profile,
    },
    {
      path: '/profile/edit:tab?',
      name: 'edit_profile',
      component: ProfileEdit,
      meta: {
        authorize: true,
      },
    },
    {
      path: '/forgot_password',
      name: 'forgot_password',
      component: ForgotPassword,
    },
    {
      path: '/confirm_account',
      component: ConfirmAccount,
    },
    {
      path: '/accept_team_invitation',
      component: AcceptTeamInvitation,
    },
    {
      path: '/contribution/thank_you',
      component: ContributionSuccess,
    },
    // TODO add 404 page template
    {
      path: '*',
      component: ForgotPassword,
    },
  ],
  scrollBehavior: (to, from) => { // eslint-disable-line
    // Check if route path changed, to avoid scrolling when changing only route query
    if (
      (to.name === 'edit_profile' ||
        to.name === 'edit_fundraising' ||
        to.name === 'edit_crowdfunding') && to.query.tab) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: '#scrollTo', offset: { x: 0, y: 70 } });
        }, 1000);
      });
    }
    if (to.name === 'edit_profile' && !to.query.tab) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 600);
      });
    }
    if (to.path !== from.path) {
      if (to.hash) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({ selector: to.hash, offset: { x: 0, y: 70 } });
          }, 600);
        });
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 200);
      });
    }
    if (to.query.category_id) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 200);
      });
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.authorize && !auth.user.authenticated) {
    router.push('/');
  } else {
    next();
  }
});

axios.interceptors.response.use(response => response, (error) => {
  const authRequest = error.config.url.includes('session');
  if (error.response.status === 401 && !authRequest) {
    auth.logout();
    location.href = '/';
  }
  return Promise.reject(error);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js